module.exports = __webpack_public_path__ + "static/Asti-41829262a97dd022192ba0b5a2c8d8ad.jpg";